import { PatientTabProps } from '~/lib/constants/patients.constants';

import PatientActivity from './patientActivity';

const PatientActivityTab = ({ patientId }: PatientTabProps) => (
  <PatientActivity patientId={patientId} />
);

export default PatientActivityTab;
